import {
    MODA_PRODUCT_FORM_REQUEST,
    MODA_PRODUCT_FORM_SUCCESS,
    MODA_PRODUCT_FORM_ERROR,
    GET_ALL_MODA_PRODUCT_FORM_REQUEST,
    GET_ALL_MODA_PRODUCT_FORM_SUCCESS,
    GET_ALL_MODA_PRODUCT_FORM_ERROR,
    GET_ONE_MODA_PRODUCT_FORM_REQUEST,
    GET_ONE_MODA_PRODUCT_FORM_SUCCESS,
    GET_ONE_MODA_PRODUCT_FORM_ERROR,
    UPDATE_MODA_PRODUCT_FORM_REQUEST,
    UPDATE_MODA_PRODUCT_FORM_SUCCESS,
    UPDATE_ONE_MODA_PRODUCT_FORM_ERROR,
    DELETE_MODA_PRODUCT_FORM_REQUEST,
    DELETE_MODA_PRODUCT_FORM_SUCCESS,
    DELETE_ONE_MODA_PRODUCT_FORM_ERROR,
    GET_ALL_MODA_PRODUCT_DETAIL_FORM_REQUEST,
    GET_ALL_MODA_PRODUCT_DETAIL_FORM_SUCCESS,
    GET_ALL_MODA_PRODUCT_DETAIL_FORM_ERROR,
} from "./types.js";
import { BASEURL } from "../../constant/config.js";
import moment from "moment";
import numeral from "numeral";

const axios = require("axios");

export const addModaProduct = (token, parent, child) => (dispatch) => {
    console.log("parent", parent)

    dispatch({ type: MODA_PRODUCT_FORM_REQUEST });


    const payload = {
        category: parent.category ? parent.category : null,
        shop_sku: parent.shop_sku ? parent.shop_sku : null,
        title: parent.title ? parent.title : null,
        designer: parent.designer ? parent.designer : null,
        variant_group_code: parent.variant_group_code ? parent.variant_group_code : null,
        vendor_color: parent.vendor_color ? parent.vendor_color : null,
        main_image: parent.main_image ? parent.main_image : null,
        description: parent.description ? parent.description : null,
        tariff_code: parent.tariff_code ? parent.tariff_code : null,
        item_number_identifier: parent.item_number_identifier ? parent.item_number_identifier : null,
        color: parent.color ? parent.color : null,
        season: parent.season ? parent.season : null,
        country_of_origin: parent.country_of_origin ? parent.country_of_origin : null,
        item_number_identifier_type: parent.item_number_identifier_type ? parent.item_number_identifier_type : null,
        customer_delivery_notes: parent.customer_delivery_notes ? parent.customer_delivery_notes : null,
        made_to_order: parent.made_to_order ? parent.made_to_order : null,
        variant_style_code: parent.variant_style_code ? parent.variant_style_code : null,
        detail_bullets: parent.detail_bullets ? parent.detail_bullets : null,
        material: parent.material ? parent.material : null,
        image_2: parent.image_2 ? parent.image_2 : null,
        image_3: parent.image_3 ? parent.image_3 : null,
        image_4: parent.image_4 ? parent.image_4 : null,
        image_5: parent.image_5 ? parent.image_5 : null,
        image_6: parent.image_6 ? parent.image_6 : null,
        image_7: parent.image_7 ? parent.image_7 : null,
        sizes_clothing: parent.sizes_clothing ? parent.sizes_clothing : null,
        fit_information: parent.fit_information ? parent.fit_information : null,
        // 
        sku: parent.shop_sku ? parent.shop_sku : null,
        product_id: parent.shop_sku ? parent.shop_sku : null,

        product_id_type: parent.product_id_type ? parent.product_id_type : null,
        offer_description: parent.offer_description ? parent.offer_description : null,
        internal_description: parent.internal_description ? parent.internal_description : null,
        price: parent.price ? parent.price : null,
        price_additional_info: parent.price_additional_info ? parent.price_additional_info : null,
        quantity: parent.quantity ? parent.quantity : 0,
        min_quantity_alert: parent.min_quantity_alert ? parent.min_quantity_alert : null,
        state: parent.state ? parent.state : null,
        available_start_date: parent.available_start_date ? parent.available_start_date : null,
        available_end_date: parent.available_end_date ? parent.available_end_date : null,
        discount_price: parent.discount_price ? parent.discount_price : 0,
        discount_start_date: parent.discount_start_date ? parent.discount_start_date : null,
        discount_end_date: parent.discount_end_date ? parent.discount_end_date : null,
        update_delete: parent.update_delete ? parent.update_delete : null,
        retail_price: parent.retail_price ? parent.retail_price : null
    };

    const childArray = child.map((item) => ({
        category: parent.category ? parent.category : null,
        shop_sku: item.product_id ? item.product_id : null,
        title: parent.title ? parent.title : null,
        designer: parent.designer ? parent.designer : null,
        variant_group_code: parent.variant_group_code ? parent.variant_group_code : null,
        vendor_color: parent.vendor_color ? parent.vendor_color : null,
        main_image: parent.main_image ? parent.main_image : null,
        description: parent.description ? parent.description : null,
        tariff_code: parent.tariff_code ? parent.tariff_code : null,
        item_number_identifier: item.item_number_identifier ? item.item_number_identifier : null,
        color: parent.color ? parent.color : null,
        season: parent.season ? parent.season : null,
        country_of_origin: parent.country_of_origin ? parent.country_of_origin : null,
        item_number_identifier_type: parent.item_number_identifier_type ? parent.item_number_identifier_type : null,
        customer_delivery_notes: parent.customer_delivery_notes ? parent.customer_delivery_notes : null,
        made_to_order: parent.made_to_order ? parent.made_to_order : null,
        variant_style_code: parent.variant_style_code ? parent.variant_style_code : null,
        detail_bullets: parent.detail_bullets ? parent.detail_bullets : null,
        material: parent.material ? parent.material : null,
        image_2: parent.image_2 ? parent.image_2 : null,
        image_3: parent.image_3 ? parent.image_3 : null,
        image_4: parent.image_4 ? parent.image_4 : null,
        image_5: parent.image_5 ? parent.image_5 : null,
        image_6: parent.image_6 ? parent.image_6 : null,
        image_7: parent.image_7 ? parent.image_7 : null,
        sizes_clothing: item.sizes_clothing ? item.sizes_clothing : null,
        fit_information: parent.fit_information ? parent.fit_information : null,
        // 
        sku: item.product_id ? item.product_id : null,
        product_id: item.product_id ? item.product_id : null,
        // 
        product_id_type: parent.product_id_type ? parent.product_id_type : null,
        offer_description: parent.offer_description ? parent.offer_description : null,
        internal_description: parent.internal_description ? parent.internal_description : null,

        price: parent.price ? parent.price : null,
        price_additional_info: parent.price_additional_info ? parent.price_additional_info : null,
        quantity: parent.quantity ? parent.quantity : 0,
        min_quantity_alert: parent.min_quantity_alert ? parent.min_quantity_alert : null,
        state: parent.state ? parent.state : null,

        available_start_date: parent.available_start_date ? parent.available_start_date : null,
        available_end_date: parent.available_end_date ? parent.available_end_date : null,
        discount_price: parent.discount_price ? parent.discount_price : 0,
        discount_start_date: parent.discount_start_date ? parent.discount_start_date : null,
        discount_end_date: parent.discount_end_date ? parent.discount_end_date : null,

        update_delete: parent.update_delete ? parent.update_delete : null,
        retail_price: parent.retail_price ? parent.retail_price : null,
        // key for child
        // parent_item_id: parent.shop_sku ? parent.shop_sku : null,
    }));

    return axios({
        method: "POST",
        url: `${BASEURL}create/modaProduct`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },

        data: {
            parent: payload,
            child: childArray
        },

    })
        .then((response) => {
            return dispatch({
                type: MODA_PRODUCT_FORM_SUCCESS,
                payload: response.data,
            });
        })
        .catch((error) => {
            return dispatch({
                type: MODA_PRODUCT_FORM_ERROR,
                payload: error.response,
            });
        });
};


export const updateModaProduct = (token, parent, child, item_id) => (dispatch) => {
    dispatch({ type: UPDATE_MODA_PRODUCT_FORM_REQUEST });

      const payload = {
        category: parent.category ? parent.category : null,
        shop_sku: parent.shop_sku ? parent.shop_sku : null,
        title: parent.title ? parent.title : null,
        designer: parent.designer ? parent.designer : null,
        variant_group_code: parent.variant_group_code ? parent.variant_group_code : null,
        vendor_color: parent.vendor_color ? parent.vendor_color : null,
        main_image: parent.main_image ? parent.main_image : null,
        description: parent.description ? parent.description : null,
        tariff_code: parent.tariff_code ? parent.tariff_code : null,
        item_number_identifier: parent.item_number_identifier ? parent.item_number_identifier : null,
        color: parent.color ? parent.color : null,
        season: parent.season ? parent.season : null,
        country_of_origin: parent.country_of_origin ? parent.country_of_origin : null,
        item_number_identifier_type: parent.item_number_identifier_type ? parent.item_number_identifier_type : null,
        customer_delivery_notes: parent.customer_delivery_notes ? parent.customer_delivery_notes : null,
        made_to_order: parent.made_to_order ? parent.made_to_order : null,
        variant_style_code: parent.variant_style_code ? parent.variant_style_code : null,
        detail_bullets: parent.detail_bullets ? parent.detail_bullets : null,
        material: parent.material ? parent.material : null,
        image_2: parent.image_2 ? parent.image_2 : null,
        image_3: parent.image_3 ? parent.image_3 : null,
        image_4: parent.image_4 ? parent.image_4 : null,
        image_5: parent.image_5 ? parent.image_5 : null,
        image_6: parent.image_6 ? parent.image_6 : null,
        image_7: parent.image_7 ? parent.image_7 : null,
        sizes_clothing: parent.sizes_clothing ? parent.sizes_clothing : null,
        fit_information: parent.fit_information ? parent.fit_information : null,
        // 
        sku: parent.shop_sku ? parent.shop_sku : null,
        product_id: parent.shop_sku ? parent.shop_sku : null,

        product_id_type: parent.product_id_type ? parent.product_id_type : null,
        offer_description: parent.offer_description ? parent.offer_description : null,
        internal_description: parent.internal_description ? parent.internal_description : null,
        price: parent.price ? parent.price : null,
        price_additional_info: parent.price_additional_info ? parent.price_additional_info : null,
        quantity: parent.quantity ? parent.quantity : 0,
        min_quantity_alert: parent.min_quantity_alert ? parent.min_quantity_alert : null,
        state: parent.state ? parent.state : null,
        available_start_date: parent.available_start_date ? parent.available_start_date : null,
        available_end_date: parent.available_end_date ? parent.available_end_date : null,
        discount_price: parent.discount_price ? parent.discount_price : 0,
        discount_start_date: parent.discount_start_date ? parent.discount_start_date : null,
        discount_end_date: parent.discount_end_date ? parent.discount_end_date : null,
        update_delete: parent.update_delete ? parent.update_delete : null,
        retail_price: parent.retail_price ? parent.retail_price : null
    };

     const childArray = child.map((item) => ({
        category: parent.category ? parent.category : null,
        shop_sku: item.product_id ? item.product_id : null,
        title: parent.title ? parent.title : null,
        designer: parent.designer ? parent.designer : null,
        variant_group_code: parent.variant_group_code ? parent.variant_group_code : null,
        vendor_color: parent.vendor_color ? parent.vendor_color : null,
        main_image: parent.main_image ? parent.main_image : null,
        description: parent.description ? parent.description : null,
        tariff_code: parent.tariff_code ? parent.tariff_code : null,
        item_number_identifier: item.item_number_identifier ? item.item_number_identifier : null,
        color: parent.color ? parent.color : null,
        season: parent.season ? parent.season : null,
        country_of_origin: parent.country_of_origin ? parent.country_of_origin : null,
        item_number_identifier_type: parent.item_number_identifier_type ? parent.item_number_identifier_type : null,
        customer_delivery_notes: parent.customer_delivery_notes ? parent.customer_delivery_notes : null,
        made_to_order: parent.made_to_order ? parent.made_to_order : null,
        variant_style_code: parent.variant_style_code ? parent.variant_style_code : null,
        detail_bullets: parent.detail_bullets ? parent.detail_bullets : null,
        material: parent.material ? parent.material : null,
        image_2: parent.image_2 ? parent.image_2 : null,
        image_3: parent.image_3 ? parent.image_3 : null,
        image_4: parent.image_4 ? parent.image_4 : null,
        image_5: parent.image_5 ? parent.image_5 : null,
        image_6: parent.image_6 ? parent.image_6 : null,
        image_7: parent.image_7 ? parent.image_7 : null,
        sizes_clothing: item.sizes_clothing ? item.sizes_clothing : null,
        fit_information: parent.fit_information ? parent.fit_information : null,
        // 
        sku: item.product_id ? item.product_id : null,
        product_id: item.product_id ? item.product_id : null,
        // 
        product_id_type: parent.product_id_type ? parent.product_id_type : null,
        offer_description: parent.offer_description ? parent.offer_description : null,
        internal_description: parent.internal_description ? parent.internal_description : null,

        price: parent.price ? parent.price : null,
        price_additional_info: parent.price_additional_info ? parent.price_additional_info : null,
        quantity: parent.quantity ? parent.quantity : 0,
        min_quantity_alert: parent.min_quantity_alert ? parent.min_quantity_alert : null,
        state: parent.state ? parent.state : null,

        available_start_date: parent.available_start_date ? parent.available_start_date : null,
        available_end_date: parent.available_end_date ? parent.available_end_date : null,
        discount_price: parent.discount_price ? parent.discount_price : 0,
        discount_start_date: parent.discount_start_date ? parent.discount_start_date : null,
        discount_end_date: parent.discount_end_date ? parent.discount_end_date : null,

        update_delete: parent.update_delete ? parent.update_delete : null,
        retail_price: parent.retail_price ? parent.retail_price : null,
        // key for child
        // parent_item_id: parent.shop_sku ? parent.shop_sku : null,
    }));


    return axios({
        method: "PUT",
        url: `${BASEURL}update/modaProduct/${item_id}`,
        headers: { Accept: "application/json", Authorization: "Bearer " + token },
        data: {
            parent: payload,
            child: childArray
        },
    }).then((response) => {
        return dispatch({
            type: UPDATE_MODA_PRODUCT_FORM_SUCCESS,
            payload: response?.data,
        });
    }).catch((error) => {
        return dispatch({
            type: UPDATE_ONE_MODA_PRODUCT_FORM_ERROR,
            payload: error.response,
        });
    });
};


export const getAllModaProduct = (token, values) => (dispatch) => {
    dispatch({ type: GET_ALL_MODA_PRODUCT_FORM_REQUEST });




    return axios({
        method: "POST",
        url: `${BASEURL}getAll/getModaProductList`,
        headers: { Accept: "application/json", Authorization: "Bearer " + token },

    }).then((response) => {
        return dispatch({
            type: GET_ALL_MODA_PRODUCT_FORM_SUCCESS,
            payload: response?.data,
        });
    }).catch((error) => {
        return dispatch({
            type: GET_ALL_MODA_PRODUCT_FORM_ERROR,
            payload: error.response,
        });
    });
};

export const getAllModaProductDetail = (token, id) => (dispatch) => {
    dispatch({ type: GET_ALL_MODA_PRODUCT_DETAIL_FORM_REQUEST });




    return axios({
        method: "POST",
        url: `${BASEURL}getAll/modaProductDetail`,
        headers: { Accept: "application/json", Authorization: "Bearer " + token },
        data: {
            p_sku: id
        }
    }).then((response) => {
        return dispatch({
            type: GET_ALL_MODA_PRODUCT_DETAIL_FORM_SUCCESS,
            payload: response?.data,
        });
    }).catch((error) => {
        return dispatch({
            type: GET_ALL_MODA_PRODUCT_DETAIL_FORM_ERROR,
            payload: error.response,
        });
    });
};


export const getOneModaProduct = (token, id) => (dispatch) => {

    dispatch({ type: GET_ONE_MODA_PRODUCT_FORM_REQUEST });
    return axios({
        method: "GET",
        url: `${BASEURL}getOne/modaProduct/${id}`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
    })
        .then((response) => {
            return dispatch({
                type: GET_ONE_MODA_PRODUCT_FORM_SUCCESS,
                payload: response.data,
            });
        })
        .catch((error) => {
            return dispatch({
                type: GET_ONE_MODA_PRODUCT_FORM_ERROR,
                payload: error.response,
            });
        });
};

export const deleteModaProduct = (token, id) => (dispatch) => {
    dispatch({ type: DELETE_MODA_PRODUCT_FORM_REQUEST });
    return axios({
        method: "DELETE",
        url: `${BASEURL}delete/modaProduct/${id}`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
    })
        .then((response) => {
            return dispatch({
                type: DELETE_MODA_PRODUCT_FORM_SUCCESS,
                payload: response.data,
            });
        })
        .catch((error) => {
            return dispatch({
                type: DELETE_ONE_MODA_PRODUCT_FORM_ERROR,
                payload: error.response,
            });
        });
};

